import { hotelServiceInstance } from "@/axios-path.js";
// fetchSaleStoreReport;
export default {
    namespaced: true,
    state: {
        clone_config_path: {
            datetime_start: null,
            datetime_end: null,
        },
        hotel_order_report_data: []
    },
    mutations: {
        CLEAR_STATE(state) {
            state.clone_config_path = {
                datetime_start: null,
                datetime_end: null,
            };
            state.hotel_order_report_data = []
        },
        SET_HOTEL_ORDER_REPORT_DATA(state, data) {
            state.hotel_order_report_data = data.map((val, index) => { return { no: index + 1, ...val } });
        },
        SET_CONFIG_PATH(state, data) {
            state.clone_config_path = data;
        }
    },
    actions: {
        async fetchHotelOrderReport({ commit }, config) {
            try {
                const response = await hotelServiceInstance.get("/api/v1/order", {
                    params: {
                        datetime_service_start: config.datetime_start,
                        datetime_service_end: config.datetime_end
                    }
                });
                commit("SET_HOTEL_ORDER_REPORT_DATA", response);
                commit("SET_CONFIG_PATH", config);
                return response;
            } catch (error) {
                return;
            }
        },
    },
    getters: {},
};
